import React from 'react';
import { Link2 } from 'lucide-react';

export const VerbundTag = ({ nr }) => (nr ? (
  <span className="shrink-0 inline-flex items-center gap-1 font-mono text-[10px] px-1.5 py-0.5 rounded-md bg-[#1B3A5C]/[0.06] text-[#1B3A5C] border border-[#1B3A5C]/15" data-testid={`verbund-tag-${nr}`}>
    <Link2 className="w-2.5 h-2.5 text-[#b8893d]" />M-{nr}
  </span>
) : null);

export const initialen = (name = '') => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || 'M';

export default VerbundTag;
